import AdminAddPasein from "../../components/AdminRole/AdminRoleAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
